import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Swatch from '@ynap/swatch';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('ProductDetailsColours');

class Colours extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { collapseColours: props.collapseColours || false };
        this.expandColours = this.expandColours.bind(this);
    }

    expandColours() {
        this.setState(() => ({ collapseColours: false }));
    }

    render() {
        const { className, colourLabel, colours, messages, loading = false, Wrapper = 'div', swatchHorizontalScroll } = this.props;

        if (loading) {
            return <div className={bem(null, 'loading', className)} />;
        }

        const showSwatches = colours.length > 1;
        const collapseColours =
            !swatchHorizontalScroll && this.state.collapseColours && colours.length > 7; /* it shows only if the product has more than 7 (1 line) colours */

        return (
            <div className={bem(null, null, className)}>
                {colourLabel && (
                    <p className={bem('colourHeading')}>
                        {messages.colourAndSize.colour()}: <span className={bem('colourName')}>{colourLabel}</span>
                    </p>
                )}
                {showSwatches && (
                    <div className={bem('coloursList')}>
                        <ul className={bem('swatchList', { collapseColours, swatchHorizontalScroll })}>
                            {colours.map((colour, index) => {
                                const { href, partNumber, swatch, notBuyable, label, selected: active } = colour;

                                return (
                                    <li className={bem('swatch', { active })} key={partNumber}>
                                        <Wrapper {...this.props} selected={active} productUrl={href} partNumber={partNumber} title={label} position={index + 1}>
                                            <Swatch colour={swatch?.HEX} url={swatch?.URL} notBuyable={notBuyable} />
                                        </Wrapper>
                                    </li>
                                );
                            })}
                        </ul>
                        {collapseColours && (
                            <div className={bem('moreColours')} onClick={this.expandColours}>
                                {messages.colourAndSize.moreColours()}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

Colours.propTypes = {
    swatchHorizontalScroll: PropTypes.bool,
    loading: PropTypes.bool,
    className: PropTypes.string,
    colourLabel: PropTypes.string,
    colours: PropTypes.array.isRequired,
    messages: PropTypes.shape({
        colourAndSize: PropTypes.shape({
            colour: PropTypes.func.isRequired,
            moreColours: PropTypes.func,
        }).isRequired,
    }),
    collapseColours: PropTypes.bool,
    Wrapper: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default Colours;
